// 用户
import request from '@/utils/request'
export function queryUserList(data) {
  return request({
    url: `/wit-energymetering-platform-api/user/queryUserList`,
    method: 'post',
    data
  })
}
// 新增
// 添加资产公共接口
export function add(data) {
  return request({
    url: `/wit-energymetering-platform-api/assert/add`,
    method: 'post',
    data
  })
}

// errorCode:1003 名称重复
// 编辑更新

export function update(data) {
  return request({
    url: `/wit-energymetering-platform-api/assert/update`,
    method: 'post',
    data
  })
}

// 用户编辑
export function updateUser(data) {
  return request({
    url: `/wit-energymetering-platform-api/user/updateUser`,
    method: 'post',
    data
  })
}
// 修改密码
export function changePwd(data) {
  return request({
    url: `/wit-energymetering-platform-api/user/changePwd`,
    method: 'post',
    data
  })
}

// 用户添加操作记录接口
export function addUserOperateRecord(data) {
  return request({
    url: `/wit-energymetering-platform-api/opearteRecord/addRecord`,
    method: 'post',
    data
  })
}

// 管理员修改密码
export function resetPwd(data) {
  return request({
    url: `/wit-energymetering-platform-api/user/resetPwd`,
    method: 'post',
    data
  })
}